import React, { useState } from 'react';

import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import AnswerTicket from "main-views/suggestion/AnswerTicket";
import ICAddIcon from "res/images/telegram.png";

const ModalAnsweTicketCard = (props) => {
    const [open, setOpen] = useState(false);


    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <div>
            <div className="answeTicketCard" onClick={handleOpen} >
                <img src={ICAddIcon}  style={{width:'1rem'}} alt="add"/>
                <span>
                     Ø«Ø¨Øª Ù¾Ø§Ø³Ø® Ø¬Ø¯ÛØ¯
                </span>
            </div>


            <Dialog open={open} onClose={handleClose}>
                <DialogContent>
                    <AnswerTicket handleClose={handleClose} onLoading={props.onLoading} {...props} />
                </DialogContent>

            </Dialog>
        </div>
    );
};

export default ModalAnsweTicketCard;
